<section role="status" aria-busy="true">
  <span class="sr-only">{{ mode === 'list' ? 'Loading recipients…' : mode === 'detail' ? 'Loading recipient story…' : 'Loading recipient updates…' }}</span>
  <div aria-hidden="true">
    <ng-container *ngIf="mode === 'list'">
      <div class="skeleton-pills"><span *ngFor="let pill of [1,2,3,4,5]" class="bone pill"></span></div>
      <span class="bone section-title"></span>
      <div class="recipient-grid">
        <div *ngFor="let card of [1,2,3]" class="skeleton-card">
          <span class="bone card-image"></span>
          <div class="skeleton-copy"><span class="bone tag"></span><span class="bone title"></span>
            <span class="bone line"></span><span class="bone line short"></span><span class="bone action"></span></div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="mode === 'detail'">
      <div class="recipients-hero skeleton-hero"><div class="recipients-hero-inner">
        <span class="bone back-link"></span><span class="bone tag"></span>
        <span class="bone hero-title"></span><span class="bone line"></span><span class="bone line short"></span>
      </div></div>
      <div class="recipient-page">
        <div *ngFor="let row of [0,1]" class="skeleton-story-row" [class.reverse]="row === 1">
          <span class="bone story-image"></span>
          <div><span *ngFor="let line of [1,2,3,4,5,6,7,8,9]" class="bone line" [class.short]="line === 4 || line === 9"></span></div>
        </div>
      </div>
    </ng-container>
    <div *ngIf="mode === 'updates'" class="skeleton-updates"><span class="bone tag"></span>
      <span class="bone title"></span><span class="bone line"></span><span class="bone line short"></span></div>
  </div>
</section>
